module.exports = __webpack_public_path__ + "static/img/logoBai.9f21040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoBai.png
// module id = fpGK
// module chunks = 1 2 3 4 5 7 8 9 13 25